// Hooks
import { useEffect, useState } from 'react';

// Translation Library
import { useTranslation } from 'react-i18next';

// Material UI Library
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import FormHelperText from '@mui/material/FormHelperText';

import { ConvertData } from '../utilities/ConvertData';

const baseURL = process.env.REACT_APP_API_BASE_URL;
const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  }, 
};


const Events = ({formData, handleChange, errorsData}) => {

    let [events, setEvents] = useState([])
    const { t, i18n } = useTranslation();
     useEffect(()=>{
       const fetchEvetns  = async ()=>{
         try {
           const res = await fetch(`${baseURL}/events`)
           if (!res.ok) {
           throw new Error(`API Error: ${res.status}`);
           }
           else {
             const data = await res.json();
             setEvents(data.data)
           }
         }
         catch(error) {
           console.log(error)
         }
       }
       fetchEvetns()
     },[])
  return (
    <>
      <FormControl className="w-full">
        <InputLabel error={errorsData.events}>{t("events")}</InputLabel>
        <Select
            multiple
            error={errorsData.events}
            name='events'
            value={formData.events}
            onChange={handleChange}
            input={<OutlinedInput label={t("events")} />}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: "wrap", gap: 1, maxHeight: 200, overflowY: 'auto' }}>
              {selected.map((element1) => {
                // console.log(selected)
                  const event = events.find(element2 => element2.id === element1);
                  // console.log(event)
                  if (!event) return null;

                  return (
                  <Box
                      key={element1}
                      sx={{
                      border: '1px solid #ccc',
                      width: "fit-content",
                      padding: "0px 5px",
                      borderRadius: 1,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 5,
                      backgroundColor: '#f5f5f5'
                      }}
                  >
                    <div>
                        <Box sx={{ fontWeight: 'bold', fontSize: '0.95rem', whiteSpace: 'normal' }}>{i18n.language === "en" ? event.name: event.name}</Box>
                        <Box sx={{ fontSize: '0.85rem', color: 'text.secondary', whiteSpace: 'normal' }}>{i18n.language === "en" ? event.description: event.description}</Box>
                        <Box sx={{ fontSize: '0.8rem', color: 'primary.main', whiteSpace: 'normal' }}>{t("start_time")} : {ConvertData(event.start_date)}</Box>
                        <Box sx={{ fontSize: '0.8rem', color: 'primary.main', whiteSpace: 'normal' }}>{t("end_time")} : {ConvertData(event.end_date)}</Box>
                        <Box sx={{ fontSize: '0.8rem', color: 'text.secondary', whiteSpace: 'normal' }}>{t("event_location")} : {event.location}</Box>
                        <Box sx={{ fontSize: '0.8rem', color: 'text.secondary', whiteSpace: 'normal' }}>{t("price")} : {event.price}</Box>
                    </div>
                    <div>
                        <img width={100} src={`${event.image}`}/>
                    </div>
                  </Box>
                  );
              })}
              </Box>
            )}
            MenuProps={MenuProps}
            >
            {events.map((eventsObj, index) => [
                <MenuItem dir={i18n.language === "en" ? "ltr" : "rtl"} key={eventsObj.id} value={eventsObj.id}>
                  <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 0.5 }}>
                    <div>
                        <Box sx={{ fontWeight: 'bold', fontSize: '0.95rem', whiteSpace: 'normal' }}>{i18n.language === "en" ? eventsObj.name: eventsObj.name}</Box>
                        <Box sx={{ fontSize: '0.85rem', color: 'text.secondary', whiteSpace: 'normal' }}>{i18n.language === "en" ? eventsObj.description: eventsObj.description}</Box>
                        <Box sx={{ fontSize: '0.8rem', color: 'primary.main', whiteSpace: 'normal' }}>{t("start_time")} : {ConvertData(eventsObj.start_date)}</Box>
                        <Box sx={{ fontSize: '0.8rem', color: 'primary.main', whiteSpace: 'normal' }}>{t("end_time")} : {ConvertData(eventsObj.end_date)}</Box>
                        <Box sx={{ fontSize: '0.8rem', color: 'text.secondary', whiteSpace: 'normal' }}>{t("event_location")} : {eventsObj.location}</Box>
                        <Box sx={{ fontSize: '0.8rem', color: 'text.secondary', whiteSpace: 'normal' }}>{t("price")} : {eventsObj.price}</Box>
                    </div>
                    <div>
                        <img width={100} src={`${eventsObj.image}`}/>
                    </div>
                  </Box>
                </MenuItem>,
                  index !== events.length - 1 && (
                    <MenuItem key={`divider-${eventsObj.id}`} disabled sx={{ p: 0, cursor: 'default' }}>
                      <div className='w-full h-[1px] bg-gray-500 mt-2 mb-2'></div>
                    </MenuItem>
                  ),
            ])}
        </Select>
        {errorsData.events 
        ? 
        (
          <FormHelperText sx={{ color: 'error.main' }}>{t("please_select_at_least_one_of_events")}</FormHelperText>
        )
        : ""}
      </FormControl>
    </>
  );
}

export default Events